import { useTranslation } from 'next-i18next';

import { formatLargeNumber } from '@/utils/number';

export const useFormatLargeNumber = () => {
  const { t } = useTranslation(['common']);

  return (num: number) => {
    const result = formatLargeNumber(num);

    switch (result.type) {
      case 'm':
        return t('common:formatNumber.m', {
          n: result.result,
        });
      case 'k':
        return t('common:formatNumber.k', {
          n: result.result,
        });
      case 'normal':
        return result.result;
    }
  };
};
